import { Pagination, Col, Row, Skeleton, Spin, Checkbox, Collapse } from 'antd';
import React, { useEffect, useState } from 'react'
import Filter from '@/components/assistant/VehiclePartsArea/Filter';
import SelectTiresCategory from './SelectTiresCategory';
import TiresHistory from './TiresHistory';
import TiresProduct from './TiresProduct'
import useTiresSectionReducer from './useTiresSectionReducer'
import { useSelector } from 'react-redux';

const { Panel } = Collapse



const TiresSection = (props) => {

  const appReducer = useTiresSectionReducer();
  const [activeKeys, setActiveKeys] = useState(['1']);

  const session = useSelector(e => e?.session);

  useEffect(() => {
    if (appReducer.state.searchText.length)
      setActiveKeys([])
    else
      setActiveKeys(['1'])
  }, [appReducer.state.searchText])


  const SunSvg = () =>
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0509 0C11.2332 0 11.4081 0.072433 11.537 0.201364C11.6659 0.330295 11.7384 0.505164 11.7384 0.6875V2.0625C11.7384 2.24484 11.6659 2.4197 11.537 2.54864C11.4081 2.67757 11.2332 2.75 11.0509 2.75C10.8685 2.75 10.6937 2.67757 10.5647 2.54864C10.4358 2.4197 10.3634 2.24484 10.3634 2.0625V0.6875C10.3634 0.505164 10.4358 0.330295 10.5647 0.201364C10.6937 0.072433 10.8685 0 11.0509 0V0ZM16.5509 11C16.5509 12.4587 15.9714 13.8576 14.94 14.8891C13.9085 15.9205 12.5096 16.5 11.0509 16.5C9.59218 16.5 8.19324 15.9205 7.16179 14.8891C6.13034 13.8576 5.55087 12.4587 5.55087 11C5.55087 9.54131 6.13034 8.14236 7.16179 7.11091C8.19324 6.07946 9.59218 5.5 11.0509 5.5C12.5096 5.5 13.9085 6.07946 14.94 7.11091C15.9714 8.14236 16.5509 9.54131 16.5509 11V11ZM21.3634 11.6875C21.5457 11.6875 21.7206 11.6151 21.8495 11.4861C21.9784 11.3572 22.0509 11.1823 22.0509 11C22.0509 10.8177 21.9784 10.6428 21.8495 10.5139C21.7206 10.3849 21.5457 10.3125 21.3634 10.3125H19.9884C19.806 10.3125 19.6312 10.3849 19.5022 10.5139C19.3733 10.6428 19.3009 10.8177 19.3009 11C19.3009 11.1823 19.3733 11.3572 19.5022 11.4861C19.6312 11.6151 19.806 11.6875 19.9884 11.6875H21.3634ZM11.0509 19.25C11.2332 19.25 11.4081 19.3224 11.537 19.4514C11.6659 19.5803 11.7384 19.7552 11.7384 19.9375V21.3125C11.7384 21.4948 11.6659 21.6697 11.537 21.7986C11.4081 21.9276 11.2332 22 11.0509 22C10.8685 22 10.6937 21.9276 10.5647 21.7986C10.4358 21.6697 10.3634 21.4948 10.3634 21.3125V19.9375C10.3634 19.7552 10.4358 19.5803 10.5647 19.4514C10.6937 19.3224 10.8685 19.25 11.0509 19.25V19.25ZM2.11337 11.6875C2.29571 11.6875 2.47058 11.6151 2.59951 11.4861C2.72844 11.3572 2.80087 11.1823 2.80087 11C2.80087 10.8177 2.72844 10.6428 2.59951 10.5139C2.47058 10.3849 2.29571 10.3125 2.11337 10.3125H0.6875C0.505164 10.3125 0.330295 10.3849 0.201364 10.5139C0.0724326 10.6428 0 10.8177 0 11C0 11.1823 0.0724326 11.3572 0.201364 11.4861C0.330295 11.6151 0.505164 11.6875 0.6875 11.6875H2.11337ZM3.00162 2.95075C3.06549 2.88673 3.14135 2.83593 3.22488 2.80127C3.3084 2.76661 3.39794 2.74877 3.48837 2.74877C3.5788 2.74877 3.66835 2.76661 3.75187 2.80127C3.8354 2.83593 3.91126 2.88673 3.97512 2.95075L5.35012 4.32575C5.47922 4.45484 5.55174 4.62993 5.55174 4.8125C5.55174 4.99507 5.47922 5.17016 5.35012 5.29925C5.22103 5.42834 5.04594 5.50087 4.86337 5.50087C4.68081 5.50087 4.50572 5.42834 4.37662 5.29925L3.00162 3.92425C2.9376 3.86039 2.8868 3.78452 2.85214 3.701C2.81749 3.61747 2.79965 3.52793 2.79965 3.4375C2.79965 3.34707 2.81749 3.25753 2.85214 3.174C2.8868 3.09048 2.9376 3.01461 3.00162 2.95075ZM3.97512 19.0493C3.84603 19.1783 3.67094 19.2509 3.48837 19.2509C3.30581 19.2509 3.13072 19.1783 3.00162 19.0493C2.87253 18.9202 2.80001 18.7451 2.80001 18.5625C2.80001 18.3799 2.87253 18.2048 3.00162 18.0757L4.37662 16.7007C4.50572 16.5717 4.68081 16.4991 4.86337 16.4991C5.04594 16.4991 5.22103 16.5717 5.35012 16.7007C5.47922 16.8298 5.55174 17.0049 5.55174 17.1875C5.55174 17.3701 5.47922 17.5452 5.35012 17.6743L3.97512 19.0493ZM19.1001 2.95075C19.0363 2.88673 18.9604 2.83593 18.8769 2.80127C18.7933 2.76661 18.7038 2.74877 18.6134 2.74877C18.5229 2.74877 18.4334 2.76661 18.3499 2.80127C18.2664 2.83593 18.1905 2.88673 18.1266 2.95075L16.7516 4.32575C16.6225 4.45484 16.55 4.62993 16.55 4.8125C16.55 4.99507 16.6225 5.17016 16.7516 5.29925C16.8807 5.42834 17.0558 5.50087 17.2384 5.50087C17.4209 5.50087 17.596 5.42834 17.7251 5.29925L19.1001 3.92425C19.1641 3.86039 19.2149 3.78452 19.2496 3.701C19.2843 3.61747 19.3021 3.52793 19.3021 3.4375C19.3021 3.34707 19.2843 3.25753 19.2496 3.174C19.2149 3.09048 19.1641 3.01461 19.1001 2.95075ZM18.1266 19.0493C18.2557 19.1783 18.4308 19.2509 18.6134 19.2509C18.7959 19.2509 18.971 19.1783 19.1001 19.0493C19.2292 18.9202 19.3017 18.7451 19.3017 18.5625C19.3017 18.3799 19.2292 18.2048 19.1001 18.0757L17.7251 16.7007C17.596 16.5717 17.4209 16.4991 17.2384 16.4991C17.0558 16.4991 16.8807 16.5717 16.7516 16.7007C16.6225 16.8298 16.55 17.0049 16.55 17.1875C16.55 17.3701 16.6225 17.5452 16.7516 17.6743L18.1266 19.0493Z" fill="#FF9900" />
    </svg>

  const KnobSvg = () =>
    <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.1728 9.46154L14.3884 11.4169L3.19293 18.9442C2.42525 19.4603 1.38254 19.2367 0.894107 18.4511C0.405674 17.6654 0.666414 16.6314 1.46895 16.1713L13.1728 9.46154Z" fill="var(--primaryColor)" />
      <rect x="18.3086" y="3.71033" width="6.64648" height="6.64648" transform="rotate(58.1298 18.3086 3.71033)" fill="var(--primaryColor)" />
      <rect x="17.627" width="2.75891" height="9.40539" rx="1.37946" transform="rotate(58.1298 17.627 0)" fill="var(--primaryColor)" />
      <rect x="23.3867" y="9.26538" width="2.75891" height="9.40539" rx="1.37946" transform="rotate(58.1298 23.3867 9.26538)" fill="var(--primaryColor)" />
      <path d="M23.3108 21.0647C24.9319 21.0647 26.2461 22.3789 26.2461 24H13.2964C13.2964 22.3789 14.6106 21.0647 16.2317 21.0647H23.3108Z" fill="var(--primaryColor)" />
    </svg>

  useEffect(() => {
    if (props.tiresCode) {
      appReducer.dispatch({ type: 'setSearchText', payload: props.tiresCode })
      appReducer.searchProduct(props.tiresCode)

    }
  }, [props.tiresCode,session?.relationId])


  return (
    <div>
      <div className='mb-5'><SelectTiresCategory reducer={appReducer} /></div>
      <Collapse onChange={setActiveKeys} activeKey={activeKeys}>
        <Panel header="History" key="1">
          <TiresHistory reducer={appReducer} />
        </Panel>


      </Collapse>

      <Row className='mt-5' gutter={16}>
        <Col lg={3}>
          <Filter reducer={appReducer} />
        </Col>




        <Col lg={21}>
          <div >
            <Skeleton active={true} loading={appReducer.state.loading}>
              <Row gutter={24}>

                {(appReducer.state.products).slice((appReducer.state.currentPage - 1) * appReducer.state.perPage, appReducer.state.currentPage * appReducer.state.perPage).map((product, key) => <Col lg={24}>

                  <TiresProduct deliveries={appReducer.state.deliveries} key={key} product={product} reducer={appReducer} />

                  

                </Col>)}
              </Row>

              {appReducer.state.products.length ? <Pagination style={{ marginTop: '20px' }} onChange={(e) => appReducer.dispatch({ type: 'setCurrentPage', payload: e })} current={appReducer.state.currentPage} total={appReducer.state.totalCount} pageSize={appReducer.state.perPage} /> : null}
            </Skeleton>
          </div>
        </Col>

      </Row>




    </div>
  )
}

export default TiresSection